module.exports = {"planTypes":{"pre":{"balance":"Saldo (R$)","buttonLabel":"Fazer Recarga","buttonAction":"recarga"},"pos":{"balance":"Limite disponível","buttonLabel":"Ver faturas","buttonAction":"fatura"}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/DashboardCashDisplay/data.json
// module id = 1903
// module chunks = 0